<template>
  <div class="md-layout">
    <div class="md-layout-item" :style="{ marginLeft: isMobile.isMobile ? '0' : '13px' }">
      <v-card :class="isMobile.isMobile ? 'ApplyMod' : ''">
        <!-- 搜索栏  -->
        <md-toolbar
          class="header"
          color="success"
          :style="{
            height: isMobile.isMobile ? '44px' : '56px',
            minHeight: isMobile.isMobile ? '44px' : '56px',
            margin: isMobile.isMobile ? '10px 0px' : '0px',
          }"
        >
          <span
            :style="{
              margin: isMobile.isMobile ? '10px' : '20px',
              width: '80px',
              float: 'left',
              color: '#fff',
            }"
            >模型申请</span
          >
          <v-spacer></v-spacer>

          <div style="display: inline-block" @mousedown="mouseDown">
            <el-cascader
              size="small"
              placeholder="全部"
              @change="onchange"
              v-model="optionsValue"
              :props="cascaderProps"
              id="coursefilterWrap"
              ref="coursefilterWrap"
              :show-all-levels="true"
              :style="{ marginTop: isMobile.isMobile ? '0px' : '12px' }"
            >
              <template slot-scope="{ node, data }">
                <span style="display: block" @click="onClick(node)">{{ data.name }}</span>
              </template>
            </el-cascader>
          </div>

          <md-button
          v-if="isMobile.isMobile"
            class="md-toolbar-toggle md-just-icon md-round md-simple"
            :class="{ toggled: $sidebar.showSidebar }"
            style="margin-right:0px;color:#fff!important"
            @click.stop="toggleSidebar"
          >
       
            <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
          </md-button>
        </md-toolbar>

        <div class="ApplyModCon">
          <v-sheet class="pa-4 lighten-2">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="请输入课程名称"
              single-line
              hide-details
              @keydown="keydownSearch"
              class="filterInput"
            ></v-text-field>
            <md-tooltip md-direction="top">按回车以检索</md-tooltip>
          </v-sheet>
          <v-card-text class="px-0 py-0 textWrap">
            <v-progress-circular
              v-if="loading"
              indeterminate
              style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; margin: auto"
              color="rgb(76, 175, 80)"
            ></v-progress-circular>

            <div>
              <v-sheet
                v-if="isLoading"
                v-for="(index, item) in 8"
                :key="index"
                :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
                class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 courseList"
              >
                <v-skeleton-loader
                  class="mx-auto"
                  max-width="100%"
                  type="list-item-two-line"
                ></v-skeleton-loader>
              </v-sheet>
              <v-treeview
                v-if="items.length > 0"
                v-model="tree"
                :open="initiallyOpen"
                :items="items"
                activatable
                item-key="_id"
                open-on-click
                @update:active="handleNodeClick"
              >
                <template v-slot:prepend="{ item, open }">
                  <v-icon v-if="!item.file">
                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                  </v-icon>
                </template>
                <template v-slot:append="{ item, open }">
                  <div class="jinDuWrap" v-if="item.type == 'task'">
                    <v-progress-linear
                      v-model="item.courseTotal"
                      color="light-green darken-1"
                      height="15"
                      rounded
                      style="margin-top: 8px"
                    >
                      <template v-slot:default="{ value }">
                        <span style="font-size: 15px">{{ item.courseTotal }}</span>
                      </template>
                    </v-progress-linear>
                  </div>
                </template>
              </v-treeview>
            </div>
          </v-card-text>
          <!-- 分页 -->
          <Pagination
            :page.sync="pagination.page"
            :total="pagination.total"
            :items-per-page.sync="pagination.itemsPerPage"
            @refresh="refreshResourceList"
          />
        </div>
        <ApplyNew
          v-if="showNewDialog"
          :showNewDialog="showNewDialog"
          :formData="auditNewData"
          :metaListData="queryParams[0].listData"
          @handleAgree="handleAgree"
          @handleReject="handleReject"
          @handleCancel="handleCancel"
        />
        <ApplyDetail :visible="visible" @close="visible = false" :clickTaskId="clickTaskId" />
      </v-card>
    </div>
  </div>
</template>
<script>
import { allCourse } from '@/api/course';
import Pagination from '@/components/Pagination/index';
import { headers } from './Setting/Header';
import moment from 'moment';
import ApplyNew from './Action/ApplyNew';
import ApplyDetail from './ApplyDetail';
import { updateNewModelResource, refreshResourceList } from '@/api/model_resource';
import { categoryList } from '../../../../api/user';
// const { io } = require('socket.io-client');
import { mapGetters } from 'vuex';
import { Background } from '@antv/x6/lib/registry';
export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: 'AppltMod',
  components: {
    ApplyNew,
    ApplyDetail,
    Pagination,
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  data() {
    return {
      isLoading: false,
      // socketValue:'',
      socket: null,
      courseTotal: 15,
      initiallyOpen: ['public'],
      iconDict: {
        course: 'mdi-school',
        project: 'mdi-grain',
        task: 'mdi-calendar-check',
      },
      tree: [],
      items: [],

      headers,
      // 搜索条件
      search: '',
      // 遮罩层
      loading: false,
      visible: false,
      // 表格数据
      list: [{ taskName: '线管敷设', modelNum: 2 }],

      // 分页
      pagination: {
        page: 1,
        itemsPerPage: 10,
        total: 0,
      },
      // 是否显示弹出框
      showNewDialog: false,
      // 元件类型字典
      metaDict: {
        scene: '场景',
        role: '角色',
        tool: '工具',
        device: '设备',
      },
      // 状态
      statusListData: [],
      // 状态字典
      statusDict: {},
      // 审核数据
      auditNewData: {},
      // 当前选中数据
      currentItem: {},
      clickTaskId: '', //点击节点id
      //头部查询字段数据
      majorGroup: '',
      majorGroup2: '',
      listData1: [
        { code: 'bjrs', name: '毕节人社' },
        { code: 'bk', name: '本科' },
        { code: 'gz', name: '高职' },
        { code: 'zz', name: '中职' },
        { code: 'gj', name: '技师学院' },
        { code: 'jx', name: '技校' },
        { code: 'qy', name: '企业' },
      ],
      listData2: [],
      listData3: [],
      type: 'bjrs',
      queryform: {
        one: {
          name: '适用',
          code: '',
        },
        level: '',
        parentCode: {
          name: '专业大类',
          code: '',
        },
        three: {
          name: '专业类',
          code: '',
        },
      },
      typeList: [
        { code: '', name: '  全部' },
        { code: 'bjrs', name: '毕节人社' },
        { code: 'bk', name: '本科' },
        { code: 'gz', name: '高职' },
        { code: 'zz', name: '中职' },
        { code: 'gj', name: '技师学院' },
        { code: 'jx', name: '技校' },
        { code: 'qy', name: '企业' },
      ],
      //头部查询字段数据
      tooltipVisible: false,
      tooltipValue: '全部',
      optionsValue: ['all'],
      cascaderProps: {
        label: 'name',
        value: 'code',
        lazy: true,
        lazyLoad: (node, resolve) => {
          let that = this;
          const { level } = node;
          setTimeout(() => {
            if (node.level == 0) {
              let options = [
                {
                  code: 'all',
                  name: '全部',
                  level: 0,
                  leaf: true,
                  children: [],
                },
                // { code: 'bjrs', name: '毕节人社', level: 0,  leaf:false, },
                { code: 'bk', name: '本科', level: 0, leaf: false },
                { code: 'gz', name: '高职', level: 0, leaf: false },
                { code: 'zz', name: '中职', level: 0, leaf: false },
                { code: 'gj', name: '技师学院', level: 0, leaf: false },
                { code: 'jx', name: '技校', level: 0, leaf: false },
                { code: 'qy', name: '企业', level: 0, leaf: false },
              ];

              resolve(options);
            }
            if (node.level == 1) {
              if (node.value == '') {
                return;
              }
              let params = {
                cate_type: node.value || '',
                level: '1',
                parentCode: '',
              };
              categoryList(params).then(res => {
                if (res.data) {
                  res.data &&
                    res.data.forEach(item => {
                      item.leaf = false;
                    });
                  if (params.cate_type !== 'all') {
                    res.data.unshift({
                      cate_type: 'all',
                      code: 'all',
                      name: '全部',
                      _id: '123456',
                      children: [],
                      leaf: true,
                      level: 1,
                    });
                  }
                  resolve(res.data);
                }
              });
            }
            if (node.level == 2) {
              let params = {
                cate_type: node.parent.value || '',
                level: '2',
                parentCode: node.value || '',
              };
              categoryList(params).then(res => {
                if (res.data) {
                  res.data.forEach(item => {
                    item.leaf = true;
                  });
                  if (params.parentCode !== 'all') {
                    res.data.unshift({
                      cate_type: 'all',
                      code: 'all',
                      name: '全部',
                      _id: '111111111111111',
                      children: [],
                      leaf: true,
                      level: 2,
                    });
                  }

                  resolve(res.data);
                }
              });
            } else if (node.level > 2) {
              resolve([]);
            }
          }, 100);
        },
      },
    };
  },

  created() {
    this.queryTreeData();
  },
  mounted() {
    this.isLoading = true;
    this.setFilter();
    // let num = this.guid()
    // console.log(num)
    // this.$socket.emit("connection", 1); //触发socket连接
  },
  watch: {
    optionsValue(val) {
      if (this.$refs.coursefilterWrap && val.length == 3) {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }
      if (this.$refs.coursefilterWrap && val.length == 2 && val[1] == 'all') {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }

      if (this.$refs.coursefilterWrap && val.length == 1 && val[0] == 'all') {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }
    },
    // 监听搜索
    queryParams: {
      handler: function (val, oldVal) {},
      immediate: true,
      deep: true,
    },
  },

  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    onClick(data) {
      this.optionsValue = data.path;
      this.queryTreeData();
      // this.setCard(data)
      this.mouseenter(data);
      this.setFilter(data);
    },
    mouseenter(data) {
      let str = '';
      if (data && data.pathLabels) {
        if (data.pathLabels.length == 1) {
          str = data.pathLabels[0];
          this.tooltipValue = str;
        } else if (data.pathLabels.length == 2) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1];
          this.tooltipValue = str;
        } else if (data.pathLabels.length == 3) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1] + '/' + data.pathLabels[2];
          this.tooltipValue = str;
        }
        this.tooltipVisible = true;
      } else {
        this.tooltipValue = '全部';
      }
    },
    setFilter(data) {
      if (!data) {
        let getNode = document.querySelector('.el-cascader .el-input__inner');
        getNode.style.width = 80 + 'px';
        return;
      }
      let getNode = document.querySelector('.el-cascader .el-input__inner');
      let str = '';
      if (data.pathLabels && data.pathLabels.length > 0) {
        data.pathLabels.forEach(item => {
          str += item;
        });
      }

      if (str.length <= 5) {
        getNode.style.width = (str.length + 3) * 18 + 'px';
        return;
      }
      if (str.length > 17) {
        getNode.style.width = str.length * 18 + 'px';
        return;
      }
      getNode.style.width = (str.length + 2) * 18 + 'px';
    },
    mouseDown() {
      this.tooltipVisible = false;
    },

    onchange(data) {},
    //   guid() {
    //     return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    //       var r = Math.random() * 16 | 0,
    //           v = c == 'x' ? r : (r & 0x3 | 0x8);
    //       return v.toString(16);
    //     });
    //   },

    // send() {
    //   //  "_top"、"_blank"、"_self"具有特殊意义的名称。
    //   //  _blank：在新窗口显示目标网页
    //   //  _self：在当前窗口显示目标网页
    //   //  _top：框架网页中在上部窗口中显示目标网页
    //    window.open('http://localhost:1025/ceshiDemo' ,'_blank', "height="+(screen.availHeight - 130)+",width="+(screen.availWidth - 105)+", top=20, left=20,toolbar=no, menubar=no, scrollbars=no, location=no, status=no");

    // },

    resetquery() {
      this.queryform.parentCode = {
        name: '专业大类',
        code: '',
      };
      this.queryform.three = {
        name: '专业类',
        code: '',
      };
      this.listData2 = [];
      this.listData3 = [];
    },

    queryTreeData() {
      this.loading = true;
      let params = {
        name: this.search || '',
        status: '12',
        refer: this.optionsValue[0] == '' ? 'all' : this.optionsValue[0] || '',
        majorGroup: this.optionsValue[1] == 'all' ? '' : this.optionsValue[1] || '',
        majorGroup2: this.optionsValue[2] == 'all' ? '' : this.optionsValue[2] || '',
        currentPage: this.pagination.page,
        perPage: this.pagination.itemsPerPage,
      };
      allCourse(params)
        .then(res => {
          this.isLoading = false;
          this.loading = false;
          this.items = res.data.row;
          this.pagination.total = res.data.total;
        })
        .catch(err => {
          this.isLoading = false;
        });
    },
    /**
     * 查询列表
     */
    refreshResourceList() {
      this.queryTreeData();
    },
    openMakeModelDialog() {
      this.visible = true;
    },
    handleNodeClick(e) {
      this.clickTaskId = e[0];
      if (this.clickTaskId) {
        this.visible = true;
      }

      console.log('e :>> ', e);
    },

    /**
     * 审核按钮
     */
    openAudit(item) {
      this.showNewDialog = true;
      console.log(item);
      this.currentItem = item;
      this.auditNewData = item;
    },
    /**
     * 时间格式化
     */
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    /**
     * 清除筛选
     */
    clearFilter() {
      this.search = '';
      this.queryParams.forEach(item => {
        item.value = 0;
        item.code = '';
      });
    },
    /**
     * 通过/驳回事件处理
     */
    handleAction(e) {
      this.showNewDialog = false;
      this.currentItem.apply_list.push({
        status: this.currentItem.status,
        remark: e.option,
        operator: this.currentItem.updater,
      });

      updateNewModelResource(this.currentItem).then(res => {
        if (res.code === '200') {
          this.$notify({
            timeout: 1500,
            message: '操作成功！',
            icon: 'add_alert',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'success',
          });
        } else {
          this.$notify({
            timeout: 1500,
            message: '操作失败',
            horizontalAlign: 'center',
            verticalAlign: 'bottom',
            type: 'warning',
          });
        }
      });
    },
    /**
     * 通过
     */
    handleAgree(e) {
      if (this.currentItem.status === 5) this.currentItem.status = 7;
      else if (this.currentItem.status === 1) this.currentItem.status = 3;
      this.handleAction(e);
    },
    /**
     * 驳回
     */
    handleReject(e) {
      if (this.currentItem.status === 5) this.currentItem.status = 6;
      else if (this.currentItem.status === 1) this.currentItem.status = 2;
      this.handleAction(e);
    },
    /**
     * 关闭弹出框
     */
    handleCancel() {
      this.showNewDialog = false;
    },
    /**
     * 搜索框点击enter事件
     */
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        // this.refreshResourceList();
        this.queryTreeData();
      }
    },
  },
};
</script>
<style  scoped>
.md-layout-item {
  padding-left: 0px;
  padding-right: 0px;
}
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.header_wrapper {
  width: 100%;
  padding: 15px;
}

.model_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  width: 100%;
  height: 60px;
  border-radius: 7px;
  background: linear-gradient(60deg, #66bb6a, #43a047);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
}

.img_wrapper {
  width: 64px;
  height: 64px;
}

.img_wrapper img {
  width: 100%;
  height: 100%;
}

.v-List-actived {
  background: #ddd;
}

.disable-color {
  color: #ddd !important;
}
.disable-color i {
  color: #ddd !important;
}

.textWrap {
  min-height: 500px;
  position: relative;
}

#coursefilterWrap {
  margin-top: 12px;
  margin-right: 10px;
  margin-left: 30px;
  /* width: 320px; */
}

/deep/ #coursefilterWrap .el-input:hover {
  /* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12); */
  box-shadow: 0 0 6px 1px #70707052;
  border-radius: 4px;
}

/deep/ #coursefilterWrap .el-input .el-input__inner {
  border: none;
  background: #4caf50 !important;
  color: #fff;
  font-weight: 700;
}

/deep/ #coursefilterWrap .el-input .el-input__inner::placeholder {
  color: #fff;
}

/deep/ #coursefilterWrap .el-input .el-input__suffix {
  color: #fff;
}

.el-cascader-menu {
  max-width: 250px;
}

.ApplyMod {
  box-shadow: none !important;
  background-color: transparent !important;
  /* 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12) */
}

.ApplyModCon {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  /* overflow: hidden;  */
  height: auto;
  background: #fff;
}

.jinDuWrap {
  width: 160px;
  height: 30px;
  overflow: hidden;
  transform: translateX(-188px);
}

@media (max-width: 600px) {
  .filterInput{
    padding-top: 0px;
    margin-top: 0px;
  }
  .ApplyMod {
    margin-right: 15px;
    margin-left: 15px;
  }
  .jinDuWrap {
    transform: translateX(0px);
  }
  .header{
    box-shadow: none !important;
    border-radius: 0px !important;
  }
}

/* @media (min-width: 600px) {

} */
/*  overflow: hidden;*/
.header {
  background: #4caf50 !important;
  height: 64px;

  /* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12); */
  margin: 0px 0px 0px 0px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
